import Vue from "vue";
import Vuex from "vuex";
import routerStore from './modules/router'
import tagsViewStore from './modules/tagsView'
import user from './modules/user'
import common from './modules/common'
import getters from './getters'
Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  getters,
  mutations: {},
  actions: {},
  modules: {
    user,
    routerStore,
    tagsViewStore,
    common
  },
});
